import React, {useEffect, useState} from "react";
import {bulkDeleteData, deleteData, getData} from "../../../../services/data";
import moment from "moment/moment";
import {ColumnsType} from "antd/es/table";
import {useStore} from "../../../../state/storeHooks";
import {CheckboxChangeEvent} from "antd/es/checkbox";
import {
    Badge,
    Button,
    Card,
    Checkbox,
    Col,
    Divider, Drawer, Dropdown,
    MenuProps,
    message,
    Popconfirm,
    Row,
    Space,
    Statistic,
    Table,
    Tag
} from "antd";
import {
    DeleteOutlined,
    DownOutlined,
    LineChartOutlined,
    QuestionCircleOutlined,
    UserOutlined
} from "@ant-design/icons";
const AnimeDefender: React.FC = () => {

    //message
    const [messageApi, contextHolder] = message.useMessage();

    //selected
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    // main loading
    const [loadingTable, setLoadingTable] = useState(true);

    //loading
    const [loadingReload, setLoadingReload] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);

    //data
    const [dataApi, setDataApi] = useState([]);


    //Hidename
    const [hidename, setHidename] = useState(false)

    const [openNoteDrawer, setOpenNoteDrawer] = useState(false);

    const {user} = useStore(({app}) => app);

    const {limitacc} = user.unwrap();

    const onChangeHidename = (e: CheckboxChangeEvent) => {
        setHidename(e.target.checked)
    };

    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        //console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        disable: true,
        selectedRowKeys,
        onChange: onSelectChange,

    };

    const refreshData = () => {
        setLoadingReload(true);
        setLoadingTable(true);
        // ajax request after empty completing
        getData(5836869368).then((res) => {
            setDataApi(res.data);
        }).then(() =>{
            messageApi.success('Refresh Success <3');
        }).catch((error) => {
            messageApi.error('Got error while getting data');
        }).finally(() => {
            setSelectedRowKeys([]);
            setLoadingReload(false);
            setLoadingTable(false)
        })
    }

    const bulkDeleteAccount = () => {
        setLoadingDelete(true);
        setTimeout(() => {
            bulkDeleteData(selectedRowKeys as string[]).then((res) => {
                //console.log(res);
            }).then(() => {
                messageApi.success(`Deleted: ${selectedRowKeys.length} account !`);
            }).catch((error) => {
                messageApi.error('Got error while deleting account');
            }).finally(() => {
                setSelectedRowKeys([]);
                setLoadingDelete(false);
                refreshData()
            })

        }, 1000);
    };

    useEffect(() => {
        getData(5836869368).then((res) => {
            setDataApi(res.data);
        }).then(() =>{
            messageApi.success('Refresh Success <3');
        }).catch((error) => {
            messageApi.error('Got error while getting data');
        }).finally(() => {
            setSelectedRowKeys([]);
            setLoadingReload(false);
            setLoadingTable(false)
        })
        document.title = 'Chimovo - Anime Defender'
    },[])

    const AutoRefreshData = () => {
        refreshData()
        messageApi.success(`Next refresh ${moment(Date.now() + 60000).fromNow() }`,10);
        messageApi.info(`Last Updated - ${moment(Date.now()).calendar()}`,15)
    }

    useEffect(() =>{
        const intervalId = setInterval(AutoRefreshData, 60000);
        return () => clearInterval(intervalId);
    })

    //Delete account

    const deleteAccount = () => {
        setLoadingDelete(true);
        setTimeout(() => {
            bulkDeleteData(selectedRowKeys as string[]).then((res) => {
                //console.log(res);
            })
            messageApi.success(`Deleted: ${selectedRowKeys.length} account !`);
            setSelectedRowKeys([]);
            setLoadingDelete(false);
            refreshData()
        }, 1000);
    };

    // Get Online - Offline

    interface DrawerProps {
        note: string,
        online: number
    }

    const getOnlineForNote = () => {
        // [ {note: 'note1', online: 0}, {note: 'note2', online: 0} ]
        let temp: DrawerProps[] = []
        // get all note
        dataApi.forEach((item: DataType) => {
            const note = item.Note
            if (!temp.find((item: DrawerProps) => item.note === note)) {
                temp.push({note: note, online: 0})
            }
        })
        // get online for each note
        dataApi.forEach((item: DataType) => {
            const note = item.Note
            const update = moment(item.updatedAt).unix()
            if (moment().unix() - update <= 120) {
                temp.find((item: DrawerProps) => item.note === note)!.online++
            }
        })
        //console.log(temp)
        return temp
    }


    const getOnline = () => {
        var temp = 0
        dataApi.forEach((item: DataType) => {
            const update = moment(item.updatedAt).unix()
            if (moment().unix() - update <= 300) {
                temp++
            }
        })
        return temp
    }

    const getOffline = () => {
        var temp = 0
        dataApi.forEach((item: DataType) => {
            const update = moment(item.updatedAt).unix()
            if (moment().unix() - update > 300) {
                temp++
            }
        })
        return temp
    }

    const getTotalGems = () => {
        let totalGems = 0;
        dataApi.forEach((item: DataType) => {
            let Gems = JSON.parse(item.Description)['Gems']
            totalGems += Gems
        })
        return totalGems
    }


    const getTotalCrystal = () => {
        let totalCrystals = 0;
        dataApi.forEach((item: DataType) => {
            let Items = JSON.parse(item.Description)['Items']

            if(Items['Trait Crystal'] != undefined && Items['Trait Crystal'] != null){
                totalCrystals += Items['Trait Crystal']
            }

        })
        return totalCrystals
    }

    const getTotalRiskyDice = () => {
        let totalRiskyDice = 0;
        dataApi.forEach((item: DataType) => {
            let Items = JSON.parse(item.Description)['Items']

            if(Items['Risky Dice'] != undefined && Items['Risky Dice'] != null){
                totalRiskyDice += Items['Risky Dice']
            }

        })
        return totalRiskyDice
    }

    const getTotalFrostBind = () => {
        let totalFrostBind = 0;
        dataApi.forEach((item: DataType) => {
            let Items = JSON.parse(item.Description)['Items']

            if(Items['Frost Bind'] != undefined && Items['Frost Bind'] != null){
                totalFrostBind += Items['Frost Bind']
            }

        })
        return totalFrostBind
    }

    const hasSelected = selectedRowKeys.length > 0;
    interface DataType {
        UsernameRoblocc: string;
        Description: string;
        Note: string
        updatedAt: string;
        accountStatus: string;
    }

    const filtersNote: any [] = [];
    const filtersNoteT: any [] = [];

    const columnsData: ColumnsType<DataType> = [
        {
            title: 'Roblox Username',
            dataIndex: 'UsernameRoblocc',
            width: '10%',
            render: (_, record) => {
                let UsernameRoblocc = record.UsernameRoblocc
                // console.log(UsernameRoblocc.length/100*30, UsernameRoblocc.length)
                return (
                    <div>
                        {!hidename ? UsernameRoblocc : (UsernameRoblocc.substring(0, UsernameRoblocc.length / 100 * 30) + "*".repeat(UsernameRoblocc.length - UsernameRoblocc.length / 100 * 30))}
                    </div>
                )
            },
            sorter: (a, b) => {
                return a.UsernameRoblocc.localeCompare(b.UsernameRoblocc)
            },
        },
        {
            title: 'Level',
            dataIndex: 'data-level',
            key: "data-level",
            render: (_, record) => {
                let Description = JSON.parse(record.Description)
                return <Tag color={"orange"}>
                    {new Intl.NumberFormat().format(Description['Level'])}
                </Tag>
            },
            sorter: (a: any, b: any) => JSON.parse(a.Description)['Level'] - JSON.parse(b.Description)['Level'],
        },
        {
            title: 'Gems',
            dataIndex: 'data-gems',
            key: "data-gems",
            render: (_, record) => {
                let Description = JSON.parse(record.Description)
                return <Tag color={"blue"}>
                    {new Intl.NumberFormat().format(Description['Gems'])}
                </Tag>
            },
            sorter: (a: any, b: any) => JSON.parse(a.Description)['Gems'] - JSON.parse(b.Description)['Gems'],
        },
        {
            title: 'Trait Crystal',
            dataIndex: 'data-trait-crystal',
            key: "data-trait-crystal",
            render: (_, record) => {
                let Description = JSON.parse(record.Description)
                return <Tag color={"purple"}>
                    {new Intl.NumberFormat().format(Description['Items']['Trait Crystal'] == undefined ? 0 : Description['Items']['Trait Crystal'])}
                </Tag>
            },
            sorter: (a: any, b: any) => JSON.parse(a.Description)['Items']['Trait Crystal'] - JSON.parse(b.Description)['Items']['Trait Crystal'],
        },
        {
            title: 'Risky Dice',
            dataIndex: 'data-risky-dice',
            key: "data-risky-dice",
            render: (_, record) => {
                let Description = JSON.parse(record.Description)
                return <Tag color={"red"}>
                    {new Intl.NumberFormat().format(Description['Items']['Risky Dice'] === undefined ? 0 : Description['Items']['Risky Dice'])}
                </Tag>
            },
            sorter: (a: any, b: any) => JSON.parse(a.Description)['Items']['Risky Dice'] - JSON.parse(b.Description)['Items']['Risky Dice'],
        },
        {
            title: 'Frost Bind',
            dataIndex: 'data-frost-bind',
            key: "data-frost-bind",
            render: (_, record) => {
                let Description = JSON.parse(record.Description)
                return <Tag color={"blue"}>
                    {new Intl.NumberFormat().format(Description['Items']['Frost Bind'] === undefined ? 0 : Description['Items']['Frost Bind'])}
                </Tag>
            },
            sorter: (a: any, b: any) => JSON.parse(a.Description)['Items']['Frost Bind'] - JSON.parse(b.Description)['Items']['Frost Bind'],
        },
        /*
        {
            title: 'Portal',
            dataIndex: 'data-portal',
            width: "15%",
            key: "data-portal",
            render: (_, record) => {
                let Description = JSON.parse(record.Description)
                let Item = Description.Items

                return (<>
                    {
                        !record.Description.includes("Portal") ? "-" :
                        Object.keys(Item).map((key: any) => {
                            if (key.includes('Portal')){
                                return (
                                    <Tag color={
                                        key.includes('Secret') ? "red" : 
                                        key.includes('Mythical') ? "volcano" :
                                        key.includes('Lengendary') ? "yellow" :
                                        key.includes('Epic') ? "purple" : "blue"
                                    } key={key} style={{margin: 4}}>
                                        {key.substring(0,key.toString().indexOf("("))} [{Item[key]}]
                                    </Tag>
                                )
                            }
                        })

                    }
                </>
                    
                )

            },
        },
        */
        {
            title: 'Last Update',
            dataIndex: 'lastUpdate',
            width: '10%',
            render: (_, record) => {
                return (
                    <>
                        {
                            moment(record.updatedAt).fromNow()
                        }
                    </>
                )
            },
            sorter: (a, b) => moment(a.updatedAt).unix() - moment(b.updatedAt).unix()
        },
        {
            title: 'Status',
            dataIndex: 'accountStatus',
            width: '10%',
            filters: [
                {
                    text: 'Active',
                    value: 'Active',
                },
                {
                    text: 'Inactive',
                    value: 'Inactive',
                },
            ],
            onFilter: (value: any, record) => {
                if (value === 'Active') {
                    return moment().unix() - moment(record.updatedAt).unix() < 300
                } else if (value === 'Inactive') {
                    return moment().unix() - moment(record.updatedAt).unix() >= 300
                } else {
                    return false
                }

            },
            render: (_, record) => {
                return (
                    <>
                        <Badge status={moment().unix() - moment(record.updatedAt).unix() >= 300 ? 'error' : 'success'}
                               text={moment().unix() - moment(record.updatedAt).unix() >= 300 ? 'Inactive' : 'Active'}/>
                    </>
                )
            },
        },
        {
            title: 'Note',
            dataIndex: 'Note',
            width: '15%',
            render: (_, record) => {
                {
                    filtersNoteT.push({
                        text: record.Note,
                        value: record.Note,
                    })

                    for (let index = 0; index < filtersNoteT.length; index++) {
                        if (!filtersNote.find(a => a.text === filtersNoteT[index].text)) {
                            filtersNote.push(filtersNoteT[index])
                        }
                    }
                }

                return (
                    <>
                        {record.Note}
                    </>
                )
            },

            filters: filtersNote,
            onFilter: (value: any, record: { Note: string; }) => record.Note.valueOf() === value,
            filterSearch: true,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => {
                const items: MenuProps['items'] = [
                    {
                        label: `Username: ${record.UsernameRoblocc}`,
                        key: '0',
                        disabled: true
                    },
                    {
                        type: 'divider',
                    },
                    {
                        label: <a onClick={() => {
                            //console.log(`Copied: ${record.UsernameRoblocc}/${record.Password}`)
                            deleteData(record.UsernameRoblocc).then((res) => {
                                messageApi.success(`Deleted account: ${record.UsernameRoblocc} !`);
                                refreshData()
                            })
                        }}><DeleteOutlined/> Delete Account</a>,
                        key: '1',
                        danger: true
                    },
                ];
                return (<Dropdown menu={{items}} trigger={['click']}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                            Action
                            <DownOutlined/>
                        </Space>
                    </a>
                </Dropdown>)
            }
            ,
        }
    ]

    return (<div>
        {contextHolder}
        <Row justify={'start'}>
            <Divider orientation="left">Roblocc Panel - Anime Defenders</Divider>
            <Col span={24} style={{padding: 6}}>
                <Card variant="borderless" title={"Account Overview"} size={"small"}>
                    <Row gutter={[12,12]}>
                        <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                            <Card size="small" title="Account Control">
                                <div style={{marginBottom: 16}}>
                                    <Space wrap>
                                        <Button
                                            type="primary"
                                            onClick={refreshData}
                                            loading={loadingReload
                                            }>
                                            Refresh
                                        </Button>

                                        <Button type="primary" onClick={() => {
                                            setOpenNoteDrawer(true)
                                        }}>Note Active</Button>

                                        <Popconfirm
                                            placement="bottom"
                                            title={'Are you sure to delete?'}
                                            description={`${selectedRowKeys.length} account`}
                                            onConfirm={bulkDeleteAccount}
                                            okText="Yes"
                                            cancelText="No"
                                            icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                                            disabled={!hasSelected}
                                        >
                                            <Button
                                                type="primary"
                                                disabled={!hasSelected}
                                                loading={loadingDelete}
                                                danger>
                                                Delete Account
                                            </Button>
                                        </Popconfirm>
                                    </Space>
                                </div>

                                <div style={{marginTop: 12}}>
                                    <Checkbox
                                        onChange={onChangeHidename}>
                                        Hide name (optional)
                                    </Checkbox>
                                </div>
                            </Card>
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                            <Card size="small" title="Accounts Status">
                                <Row gutter={[12, 12]}>
                                    <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                                        <Card size="small" hoverable={true}>
                                            <Statistic
                                                title="Active"
                                                value={getOnline()}
                                                valueStyle={{color: '#6abe39'}}
                                                prefix={<UserOutlined/>}
                                            />
                                        </Card>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                                        <Card size="small" hoverable={true}>
                                            <Statistic
                                                title="Inactive"
                                                value={getOffline()}
                                                valueStyle={{color: '#e84749'}}
                                                prefix={<UserOutlined/>}
                                            />
                                        </Card>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={12} xl={8}>
                                        <Card size="small" hoverable={true}>
                                            <Statistic
                                                title="Total"
                                                value={getOffline() + getOnline()}
                                                valueStyle={{color: '#535dff'}}
                                                prefix={<UserOutlined/>}
                                                suffix={`/ ${limitacc}`}
                                            />
                                        </Card>
                                    </Col>
                                </Row>
                            </Card>

                        </Col>
                    </Row>
                </Card>
            </Col>

            <Col span={24} style={{padding: 6}}>
                <Card variant="borderless" title={"Data Overview"} size={"small"}>
                    <Row gutter={[12,12]}>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                            <Card>
                                <Statistic
                                    title="Total Crystal (All account)"
                                    value={getTotalCrystal()}
                                    prefix={<LineChartOutlined />}
                                    valueStyle={{color: '#beb1ff'}}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                            <Card>
                                <Statistic
                                    title="Total Gems (All account)"
                                    value={getTotalGems()}
                                    prefix={<LineChartOutlined />}
                                    valueStyle={{color: '#5487ff'}}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                            <Card>
                                <Statistic
                                    title="Total Risky Dice (All account)"
                                    value={getTotalRiskyDice()}
                                    prefix={<LineChartOutlined />}
                                    valueStyle={{color: '#eb4034'}}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                            <Card>
                                <Statistic
                                    title="Total Frost Bind (All account)"
                                    value={getTotalFrostBind()}
                                    prefix={<LineChartOutlined />}
                                    valueStyle={{color: '#4958fc'}}
                                />
                            </Card>
                        </Col>
                    </Row>
                </Card>

            </Col>
        </Row>
        <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{paddingTop: 32}}>
                <Table
                    rowSelection={rowSelection}
                    columns={columnsData}
                    dataSource={dataApi}
                    rowKey={(record) => record.UsernameRoblocc}
                    loading={loadingTable}
                    size={"small"}
                    scroll={{x: true}}
                    bordered
                    pagination={{
                        total: dataApi.length,
                        pageSizeOptions: [25, 100, 200, 500, 1000, 2000, 5000],
                        position: ['topRight'],
                        defaultPageSize: 25,
                        showSizeChanger: true,
                    }}
                    summary={
                        (dataApi) => {

                            //Data
                            let totalGems = 0;
                            let totalCrystals = 0;
                            let totalRiskyDice = 0
                            let totalFrostBind = 0


                            //Status account
                            let countAccount = 0;
                            let countAccountInActive = 0

                            dataApi.forEach((record) => {
                                let Description = JSON.parse(record.Description)
                                
                                if (moment().unix() - moment(record.updatedAt).unix() < 300){
                                    countAccount++;
                                }
                                else {
                                    countAccountInActive++;
                                }
                                totalGems += Description['Gems']

                                let Items = Description['Items']

                                if(Items['Trait Crystal'] != undefined && Items['Trait Crystal'] != null){
                                    totalCrystals += Items['Trait Crystal']
                                }

                                if(Items['Risky Dice'] != undefined && Items['Risky Dice'] != null){
                                    totalRiskyDice += Items['Risky Dice']
                                }

                                if(Items['Frost Bind'] != undefined && Items['Frost Bind'] != null){
                                    totalFrostBind += Items['Frost Bind']
                                }

                            })

                            return (
                                <Table.Summary fixed>
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0} colSpan={2}> Summary </Table.Summary.Cell>
                                        <Table.Summary.Cell index={1}> - </Table.Summary.Cell>
                                        <Table.Summary.Cell index={2}>
                                            <Tag color={"red"}>
                                                {new Intl.NumberFormat().format(totalGems)}
                                            </Tag>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={3}>
                                            <Tag color={"red"}>
                                                {new Intl.NumberFormat().format(totalCrystals)}
                                            </Tag>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={4}>
                                            <Tag color={"red"}>
                                                {new Intl.NumberFormat().format(totalRiskyDice)}
                                            </Tag>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={5}>
                                            <Tag color={"red"}>
                                                {new Intl.NumberFormat().format(totalFrostBind)}
                                            </Tag>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={6}> - </Table.Summary.Cell>
                                        <Table.Summary.Cell index={7}> - </Table.Summary.Cell>
                                        <Table.Summary.Cell index={8}>
                                        <Space>
                                            <Tag>
                                                <Badge
                                                    status={'success'}
                                                    text={countAccount.toString()}
                                                />
                                            </Tag>
                                            <Tag>
                                                <Badge
                                                    status={'error'}
                                                    text={countAccountInActive.toString()}
                                                />
                                            </Tag>
                                        </Space>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={9}> - </Table.Summary.Cell>
                                    <Table.Summary.Cell index={10}> - </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                </Table.Summary>
                            )
                        }
                    }
                    sticky={{ offsetHeader: 0 }}
                />
            </Col>
        </Row>

        <Drawer
            title="Active per Note"
            placement="right"
            closable={true}
            onClose={() => {
                setOpenNoteDrawer(false)
            }}
            open={openNoteDrawer}
            getContainer={false}>
            <Table
                dataSource={getOnlineForNote()}
                columns={[
                    {
                        title: 'Note',
                        dataIndex: 'note',
                    },
                    {
                        title: 'Online',
                        dataIndex: 'online',
                    }
                ]}
                rowKey={(record) => record.note}
            ></Table>
        </Drawer>

    </div>);
}

export default AnimeDefender;